import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React from 'react';
import {mobileOnlyLinaria} from '../../../constants/customMedia';
import {Button} from '../../atoms/Buttons/Button';
import {Text} from '../../atoms/Text/Text';
import {ProductColorOptionsProps} from '../ProductColorOptions/ProductColorOptions';
import {SoldOutInfoHeader} from './SoldOutInfoHeader';

interface SoldOutInfoProps {
  productImage: {
    src: string;
    description: string;
    isEnclosed: boolean;
  };
  colorOptions: ProductColorOptionsProps['options'] | null;
  open: VoidFunction;
  className?: string;
  style?: React.CSSProperties;
  onColorOptionMouseLeave?: VoidFunction;
  onColorOptionMouseEnter?: VoidFunction;
  disableHoverEffect?: boolean;
  condensed?: boolean;
  ColorOptionsComponent?: React.ReactNode;
}

export const SoldOutInfo: React.FC<SoldOutInfoProps> = ({
  productImage,
  colorOptions,
  open,
  className,
  style,
  condensed,
  ColorOptionsComponent,
}) => {
  const {t} = useTranslation();

  return (
    <>
      <div className={className} style={style}>
        <SoldOutInfoHeader
          productImage={productImage}
          hasColorOptions={Boolean(colorOptions)}
          condensed={condensed}
        />
        <ReminderButton data-testid="sizeReminderButton" onClick={() => open()}>
          {t('Remind me when this is available')}
        </ReminderButton>
      </div>
      {colorOptions && (
        <ColorOptions>
          <MoreColorsText size="px22" weight="bold">
            {t('Discover other colours')}
          </MoreColorsText>
          {ColorOptionsComponent}
        </ColorOptions>
      )}
    </>
  );
};

const ReminderButton = styled(Button)`
  width: 100%;
  margin-top: 2rem;
`;

const ColorOptions = styled.div`
  padding: 0 1rem;
  text-align: center;
`;

const MoreColorsText = styled(Text)`
  display: block;
  margin-bottom: 2rem;

  ${mobileOnlyLinaria('margin: 1rem 0;')}
`;
